import styled from 'styled-components'

export const Container = styled.div`
    margin-top: 1rem;
    padding: 1.5rem;
    border-radius: 0.25rem;
    background: #fef1f2;
`

export const Title = styled.h1`
    color: #161616;
    font-size: 1rem;
    font-weight: 500;
    line-height: 150%; /* 1.5rem */
    display: flex;
    align-items: center;
    justify-content: flex-start;

    & svg {
        margin-right: 0.5rem;
    }
`

export const Text = styled.p`
    color: #666;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 170%; /* 1.4875rem */
    margin: 0.5rem 0;
`

export const TextBold = styled.p`
    color: #363636;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 150%; /* 1.3125rem */
`
